import { Case } from "./types.js";
import { caseTransfer, isObject } from "./cases.js";
export const mergeOptions = (...list) => list.reduce((acc, options) => {
  const mergedOptions = Array.isArray(options) ? mergeOptions(...options) : options;
  if (!mergedOptions) return acc;
  return {
    ...acc,
    ...mergedOptions,
    ...acc.onRequest && mergedOptions.onRequest ? {
      onRequest: async (context) => {
        await acc.onRequest?.(context);
        await mergedOptions.onRequest?.(context);
      }
    } : {},
    ...acc.onResponse && mergedOptions.onResponse ? {
      onResponse: async (context) => {
        await acc.onResponse?.(context);
        await mergedOptions.onResponse?.(context);
      }
    } : {},
    ...acc.onRequestError && mergedOptions.onRequestError ? {
      onRequestError: async (context) => {
        await acc.onRequestError?.(context);
        await mergedOptions.onRequestError?.(context);
      }
    } : {},
    ...acc.onResponseError && mergedOptions.onResponseError ? {
      onResponseError: async (context) => {
        await acc.onResponseError?.(context);
        await mergedOptions.onResponseError?.(context);
      }
    } : {},
    // TODO: headers might be function for global dynamic headers (like Authorization header for example)
    headers: { ...acc.headers || {}, ...mergedOptions.headers || {} }
  };
}, {});
export const validateParameters = async (schemas, parameters, field) => {
  const _parameters = parameters;
  const _schemas = schemas;
  return _parameters?.[field] && (_schemas?.[field]?.validate(_parameters[field]) || _parameters[field] || void 0);
};
export const prepareRequestBody = (body, options) => {
  if (!body || body instanceof FormData) return body;
  if (options.formData && isObject(body)) {
    const formData = new FormData();
    Object.entries(body).forEach(([key, value]) => {
      if (Array.isArray(value)) value.forEach((item) => formData.append(key, item));
      else formData.append(key, value);
    });
    return formData;
  }
  return caseTransfer(body, Case.snake);
};
